<p-panel [toggleable]="true" [collapsed]="true">
    <ng-template pTemplate="header">
        <div class="d-flex h4">
            Cards you've received
        </div>
    </ng-template>
    <ng-template pTemplate="content">
        <p-dataView [value]="customerService.publicCustomer.value.giftCardsReceived"
            [paginator]="customerService.publicCustomer.value.giftCardsReceived?.length > 5" [rows]="5">
            <ng-template pTemplate="header">
                <div *ngIf="customerService.publicCustomer.value.giftCardsReceived && customerService.publicCustomer.value.giftCardsReceived.length > 0"
                    class="h4">Cards you've received</div>
            </ng-template>
            <ng-template let-rec pTemplate="listItem">
                <div class="w-100">
                    <div class="d-flex w-100">
                        <div class="ms-1">
                            {{rec.venueName}}
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="ms-1">
                            <div>
                                Original balance
                            </div>
                            <div>
                                {{rec.transactionAmount |
                                currency}}
                            </div>
                        </div>
                        <div class="ms-auto" *ngIf="rec.activated && rec.EGiftCardPool">
                            <div>
                                Current balance
                            </div>
                            <div class="p-text-right">
                                <p-skeleton *ngIf="!rec.balanceCheckCompleted"></p-skeleton>
                                {{rec.currentBalance | currency}}
                            </div>
                        </div>
                        <div class="ms-auto" *ngIf="!rec.activated">
                            <div>
                                <i>
                                    <a [href]="rec.activationUrl" target="_blank">Activate now!</a>
                                </i>
                            </div>
                            <div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex">
                        From {{rec.purchaserFirstName}} {{rec.purchaserLastName}}
                    </div>
                    <div class="d-flex ms-3" *ngIf="rec.note">
                        <i>{{rec.note}}</i>
                    </div>
                    <div class="d-flex" *ngIf="rec.cardNumber">
                        {{rec.cardNumber}}
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="empty">
                <div class="d-flex w-100">
                    <div class="mx-auto">
        
                    </div>
                </div>
            </ng-template>
        </p-dataView>
    </ng-template>
</p-panel>
